<div *ngIf="isBusy" class="spinner-overlay">
  <div class="spinner-wrapper">
    <img src="../assets/hires-logo.png" class="spinner spin-breathe" />
  </div>
</div>
<app-splash *ngIf="showSplash" (done)="showSplash = false" @fadeInOut></app-splash>
<header class="app-header" *ngIf="!showSplash" @fadeInOut>
  <div class="header-left">
    <a routerLink="/events">
      <img src="assets/hires-logo.png" alt="Logo" class="logo" (click)="navigate('/events')" />
    </a>
  </div>

  <div class="header-right" (clickOutside)="closeMenu()">
    <div
      *ngIf="isAuthenticated"
      class="user-avatar"
      (click)="toggleMenu($event)">
      {{ userInitials }}
    </div>

    <div class="avatar-menu" *ngIf="menuOpen">
      <button (click)="navigate('/profile')">My Profile</button>
      <button *ngIf="hasPlayerAdmin" (click)="navigate('/admin/players')" >Manage Players</button>
      <button (click)="logout()">Logout</button>
    </div>
  </div>
</header>

<main class="app-content" [class.visible]="!showSplash" [class.has-bottom-nav]="isAuthenticated && !showSplash">
  <div *ngIf="!showSplash" @fadeInOut class="app-container">
    
    <!-- Your main app content -->
    <router-outlet />
   </div>
</main>

<nav class="bottom-nav" *ngIf="isAuthenticated && !showSplash">
  <a class="bottom-nav-item" routerLink="/events" routerLinkActive="active">
    <img src="assets/noun_Golf_8226642_FFFFFF_@100.png" alt="" class="bottom-nav-icon" />
    <span class="bottom-nav-label">Events</span>
  </a>
  <a class="bottom-nav-item" routerLink="/barn" routerLinkActive="active">
    <img src="assets/noun_Barn_8450707_FFFFFF_@100.png" alt="" class="bottom-nav-icon" />
    <span class="bottom-nav-label">Barn Availability</span>
  </a>
</nav>